const listeners = new Set();

/**
 * @typedef {'success'|'error'|'info'|'warning'} SnackVariant
 *
 * @typedef {Object} Snack
 * @property {string} message
 * @property {SnackVariant} [variant]
 * @property {number} [durationMs]
 */

/**
 * Subscribe to snackbar events.
 * @param {(snack: Snack) => void} listener
 * @returns {() => void} unsubscribe
 */
export function subscribeToSnacks(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/**
 * Enqueue a snackbar message.
 * @param {Snack} snack
 */
export function enqueueSnack(snack) {
  for (const listener of listeners) listener(snack);
}

export function snackSuccess(message, durationMs) {
  enqueueSnack({ message, variant: 'success', durationMs });
}

export function snackError(message, durationMs) {
  enqueueSnack({ message, variant: 'error', durationMs });
}

